import { CustomNumberField } from "components/shared/form";
import VehicleOwnership from "components/shared/vehicleOwnership";
import { featureModuleTypesEnum } from "helpers/enums";
import { trailerNumber } from "helpers/validators";
import React from "react";

const Markup = ({
    renderField,
    renderSelect,
    renderMechanic,
    renderFuelTanks,
    renderCheckbox,
    Button,
    setValue,
    setCustomNumberMode,
    data = {},
    ...props
}) => {
    const {
        number,
        brandTypeId,
        loadUnloadOptions,
        typeId,
        carrying,
        volume,
        ownershipType,
        ownershipBasisDocuments,
        comment,
        transportColumnId,
        trackerId,
        isInRefuelingSyncList,
        availableFeatureModules,
        accessPermitIds,
        refuelingSettings,
        organizationName,
        ownershipDisabled,
    } = props;
    const useCustomNumber = !!data.useCustomNumber;

    return (
        <div>
            <CustomNumberField
                number={number}
                numberValidator={trailerNumber}
                onCustomNumberChange={setCustomNumberMode}
                renderField={renderField}
                useCustomNumber={useCustomNumber}
            />
            {renderSelect(brandTypeId)}
            {renderSelect(typeId)}
            <VehicleOwnership
                carrying={carrying}
                data={data}
                disabled={ownershipDisabled}
                organizationName={organizationName}
                ownershipBasisDocuments={ownershipBasisDocuments}
                ownershipType={ownershipType}
                renderField={renderField}
                renderSelect={renderSelect}
                setValue={setValue}
                volume={volume}
            />
            {renderSelect({
                ...loadUnloadOptions,
                onChange: ({ name, value }) => setValue({ name, value: value.map((id) => ({ id })) }),
                value: data[loadUnloadOptions.inputProps.name].map((option) => option.id),
            })}
            {renderSelect(transportColumnId)}
            {renderMechanic(trackerId)}
            {renderSelect(trackerId)}
            {renderField(comment)}
            {availableFeatureModules.includes(featureModuleTypesEnum.RefuelingPlanning) &&
                !refuelingSettings.hideRefuelingPlanning &&
                renderCheckbox(isInRefuelingSyncList)}
            {renderSelect(accessPermitIds)}
            {renderFuelTanks()}
            {!!Button && <Button />}
        </div>
    );
};

export default Markup;
